import Links from '@/shared/constants/navegacao';
import Loading from '@/shared/components/Carregando';
import MyContext from '@/shared/contexts/AppContext';
import { Link } from 'react-router-dom';
import { PerInternFilters } from './PerInternFilters';
import { PerInternModals } from './PerInternModals';
import { PerInternTable } from './PerInternTable';
import { useContext } from 'react';
import { useDataTableState } from '@/shared/components/tables/useDataTableState';
import { usePerIntern } from './usePerIntern';

export default function AttendanceSheetsPerInternPage() {
  const context = useContext(MyContext);
  if (!context) throw new Error('Contexto deve ser usado dentro de um Provedor.');

  const tableState = useDataTableState('ano');
  tableState.pageSize = 1000;
  const {
    estagiarioId, setEstagiarioId,
    estagio, setEstagio,
    estagiarios, estagios,
    estagiarioNome,
    registros, handleBuscar,
    isExecuting, handleCriarFolha,
    selectedItem, setSelectedItem,
    folhaSelecionada, setFolhaSelecionada,
    showModalCriarFolha, setShowModalCriarFolha,
    showModalNotificacaoIndividual, setShowModalNotificacaoIndividual,
    showModalResponsavel, setShowModalResponsavel,
    showModalAssinaturas, setShowModalAssinaturas,
    folhaParaAssinaturas, setFolhaParaAssinaturas,
    loaded
  } = usePerIntern();

  if (!loaded)
    return <Loading />;

  return (
    <>
      <div className="row">
        <div className="col-md-8">
          <h3 className="pt-4">Folhas de Frequências por Estagiário</h3>
          <span className="blockquote-footer pb-4 text-end">
            Visualize todas as folhas de frequência de um estagiário específico.
          </span>
        </div>

        <div className="col-md-4">
          <br />
          <Link
            className="btn btn-sm btn-outline-secondary float-end ms-4"
            to={Links.Auth_Logout}
            title="Sair do sistema"
          >
            Sair
          </Link>
        </div>
      </div>
      <hr />

      <PerInternFilters
        estagiarioId={estagiarioId}
        setEstagiarioId={setEstagiarioId}
        estagio={estagio}
        setEstagio={setEstagio}
        estagiarios={estagiarios}
        estagios={estagios}
        tableState={tableState}
      />

      {registros && (
        <PerInternTable
          registros={registros}
          tableState={tableState}
          handleBuscar={handleBuscar}
          setSelectedItem={setSelectedItem}
          setShowModalCriarFolha={setShowModalCriarFolha}
          setFolhaSelecionada={setFolhaSelecionada}
          setShowModalResponsavel={setShowModalResponsavel}
          setShowModalNotificacaoIndividual={setShowModalNotificacaoIndividual}
          setFolhaParaAssinaturas={setFolhaParaAssinaturas}
          setShowModalAssinaturas={setShowModalAssinaturas}
        />
      )}

      <PerInternModals
        folhaSelecionada={folhaSelecionada}
        selectedItem={selectedItem}
        estagioId={estagio?.id}
        showModalResponsavel={showModalResponsavel}
        setShowModalResponsavel={setShowModalResponsavel}
        showModalNotificacaoIndividual={showModalNotificacaoIndividual}
        setShowModalNotificacaoIndividual={setShowModalNotificacaoIndividual}
        showModalCriarFolha={showModalCriarFolha}
        setShowModalCriarFolha={setShowModalCriarFolha}
        isExecuting={isExecuting}
        handleCriarFolha={handleCriarFolha}
        estagiarioNome={estagiarioNome}
        showModalAssinaturas={showModalAssinaturas}
        setShowModalAssinaturas={setShowModalAssinaturas}
        folhaParaAssinaturas={folhaParaAssinaturas}
      />
    </>
  );
}
